module.exports = __webpack_public_path__ + "2877c95f84e4ddac6077e06b8712fe84.png";